//TODO: extend for pos, and flip
var rotateTransform = function(data) {
    var transform = "";
    // Rotate around point [rotate(a x y)] changed to [transform(x y) rotate(a) translate (-x -y)], this is to keep imagemagick happy, which cannot rotate around a point, they are functionally equivilent operations.
    if(data.angle && data.angle() != 0)
        transform +=
            "translate(" + parseFloat(data.pos().getX()) + " " + parseFloat(data.pos().getY()) + ") " +
            "rotate(" + parseFloat(data.angle()) + ") " +
            "translate(" + parseFloat(-data.pos().getX()) + " " + parseFloat(-data.pos().getY()) + ") ";
    return transform;
};

module.exports.rotateTransform = rotateTransform;

//TODO: extend for pos, and flip
var rotateTransformText = function(data) {
    var transform = "";
    // Rotate around point [rotate(a x y)] changed to [transform(x y) rotate(a) translate (-x -y)], this is to keep imagemagick happy, which cannot rotate around a point, they are functionally equivilent operations.
    if(data.angle){
        if(data.keepReadable && data.keepReadable() && data.angle() > 90 && data.angle() <= 270){
           var box = data.boundingBox();
            var centroid = box.getCenter();
            transform +=
                "translate(" + parseFloat(centroid.x) + " " + parseFloat(centroid.y) + ") " +
                "rotate(" + 180 + ") " +
                "translate(" + parseFloat(-centroid.x) + " " + parseFloat(-centroid.y) + ") ";
        } 
        
    }

    var textPos = data.pos();
    transform +='translate ('+textPos.x+','+textPos.y+')';

    if(data.angle){
        var textAngle = data.angle();
        transform +='rotate ('+textAngle+')';
    }
    
    var textAngle = data.angle();
    transform += "scale( 1, -1) ";

    return transform;
};

module.exports.rotateTransformText = rotateTransformText;


var translateTransform = function(data) {
    var transform = 'translate(' + parseFloat(data.pos().x)  + ',' + parseFloat(data.pos().y) + ') ';
    return transform;
};

module.exports.translateTransform = translateTransform;


var styleToCSS = function (data) {
    var stroke_color = data.color();
    var css = "";
    if(data.fill) {
        if(data.fill() === false) {
            css += 'fill:none;';
        } else if(data.fill() === true) {
        	if(stroke_color)
	            css += 'fill:'+stroke_color+';';
        } else {
            css += 'fill:'+data.fill()+';';
        }
    }
    if(data.strokeWidth() != undefined) css += 'stroke-width:'+data.strokeWidth()+';';
    if(stroke_color != undefined) css += 'stroke:'+stroke_color+';';
    return css;
};

module.exports.styleToCSS = styleToCSS;


var styleToAttributes = function (data) {
    // NO! /taylor
    //var stroke_color = data.color();
    var stroke_color = null;
    var attrs = {};
    if(data.fill) {
        if(data.fill() === false) {
            attrs.fill = 'none';
        } else if(data.fill() === true) {
            if(stroke_color)
                attrs.fill = stroke_color;
        } else {
            attrs.fill = data.fill();
        }
    }
    if(data.strokeWidth() != undefined) attrs.strokeWidth = data.strokeWidth();
    if(stroke_color != undefined) attrs.stroke = stroke_color;
    return attrs;
};

module.exports.styleToAttributes = styleToAttributes;
